export const CHAT_ENABLE_ACTION = "Chat Enable Action";
export const CHAT_DISABLE_ACTION = "Chat Disable Action";

const initialState = false;

export function ChatReducer(state = initialState, action) {
	if (action.type === CHAT_ENABLE_ACTION) {
		return true;
	}

	if (action.type === CHAT_DISABLE_ACTION) {
		return false;
	}

	return state;
}
